module.exports = __webpack_public_path__ + "img/stock3.3128c3d8.png";